// src/pages/ChangePassword.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import lockedIcon from '../assets/locked.png';
import leftArrow from '../assets/left.png';
import backgroundImage from '../assets/back.jpg';

const ChangePassword = () => {
  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center px-4 py-12" style={{ fontFamily: 'var(--font-body)' }}>
      {/* Background photo, tied to the palette with a duotone overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center -z-10"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />
      <div
        className="absolute inset-0 -z-10"
        style={{ background: 'linear-gradient(160deg, rgba(22,38,43,0.85) 0%, rgba(14,124,123,0.55) 100%)' }}
      />

      <Link
        to="/"
        className="absolute top-6 left-6 bg-white/90 backdrop-blur rounded-full p-2.5 shadow-md hover:bg-white transition-colors duration-200"
      >
        <img src={leftArrow} alt="Back to Home" className="w-5 h-5" />
      </Link>

      <div className="bg-white/95 backdrop-blur-sm border border-[var(--mist)] shadow-xl p-8 rounded-3xl w-full max-w-md">
        <span
          className="block text-[var(--coral)] text-xs tracking-[0.2em] uppercase text-center mb-2"
          style={{ fontFamily: 'var(--font-mono)' }}
        >
          Account Security
        </span>
        <h2
          className="text-3xl font-medium text-center text-[var(--ink)] mb-6"
          style={{ fontFamily: 'var(--font-display)' }}
        >
          Change Password
        </h2>

        <form id="form" action="/action_page.php" autoComplete="off" method="post">
          <p className="text-[var(--ink)]/70 text-center mb-6">
            Your new password must be different from your previous password
          </p>

          <div className="mb-6">
            <label htmlFor="oldPassword" className="block text-[var(--ink)] text-sm font-medium mb-2">Old Password</label>
            <div className="relative">
              <img src={lockedIcon} className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 opacity-60" alt="" />
              <input
                id="oldPassword"
                name="oldPassword"
                type="password"
                placeholder="············"
                pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                title="Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters and one or more of these special characters: .@$!%*#?&><)(^-_"
                required
                className="w-full pl-11 pr-4 py-2.5 border border-[var(--mist)] rounded-xl focus:outline-none focus:ring-2 focus:ring-[var(--teal)] transition-shadow"
              />
            </div>
            <div className="text-[var(--coral)] text-sm mt-1"></div>
          </div>

          <div className="mb-6">
            <label htmlFor="newPassword" className="block text-[var(--ink)] text-sm font-medium mb-2">New Password</label>
            <div className="relative">
              <img src={lockedIcon} className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 opacity-60" alt="" />
              <input
                id="newPassword"
                name="newPassword"
                type="password"
                placeholder="············"
                pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                title="Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters and one or more of these special characters: .@$!%*#?&><)(^-_"
                required
                className="w-full pl-11 pr-4 py-2.5 border border-[var(--mist)] rounded-xl focus:outline-none focus:ring-2 focus:ring-[var(--teal)] transition-shadow"
              />
            </div>
            <div className="text-[var(--coral)] text-sm mt-1"></div>
          </div>

          <div className="mb-6">
            <label htmlFor="confirmPassword" className="block text-[var(--ink)] text-sm font-medium mb-2">Confirm Password</label>
            <div className="relative">
              <img src={lockedIcon} className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 opacity-60" alt="" />
              <input
                id="confirmPassword"
                name="confirmPassword"
                type="password"
                placeholder="············"
                pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                title="Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters and one or more of these special characters: .@$!%*#?&><)(^-_"
                required
                className="w-full pl-11 pr-4 py-2.5 border border-[var(--mist)] rounded-xl focus:outline-none focus:ring-2 focus:ring-[var(--teal)] transition-shadow"
              />
            </div>
            <div className="text-[var(--coral)] text-sm mt-1"></div>
          </div>

          <button
            type="submit"
            className="w-full bg-[var(--teal)] hover:bg-[var(--teal-deep)] text-white font-medium py-2.5 px-4 rounded-full text-lg transition-colors duration-200 mt-2"
          >
            Save
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
